export default __webpack_public_path__ + "static/media/es-ga.405f1912.svg";